import React from 'react';
import { SOCIAL_LINKS } from '../data/sectionsData';

export default function ContactSection() {
    return (
        <>
            <section className="bg-inverse-surface py-16 md:py-24 px-4 md:px-6 text-center" id="contact">
                <div className="max-w-[800px] mx-auto">
                    <div className="mb-12 reveal text-center">
                        <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-blue/15 text-accent-blue rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                            <i className="fa-solid fa-handshake-angle"></i> Contact
                        </span>
                        <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-inverse-on-surface mb-2">Let's Connect</h2>
                        <p className="text-[1.0625rem] text-inverse-on-surface max-w-[560px] mx-auto leading-relaxed">
                            Whether it's a project, a technology gig, or just a chat about motorcycles, I'd love to hear from you.
                        </p>
                    </div>

                    {/* Social links */}
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4 flex-wrap mb-12 reveal reveal-delay-1">
                        {SOCIAL_LINKS.map((s, i) => (
                            <a
                                href={s.href}
                                key={i}
                                className={`${s.cls} flex items-center gap-2 px-6 py-3.5 bg-white/[0.06] rounded-full text-inverse-on-surface text-[0.9375rem] font-medium border border-white/[0.08] hover:bg-white/[0.12] hover:-translate-y-0.5 hover:border-white/20 transition-all duration-200 ease-standard w-full md:w-auto max-w-[300px] justify-center`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className={`${s.icon} text-xl`}></i> {s.label}
                            </a>
                        ))}
                    </div>

                    {/* Email CTA */}
                    <div className="reveal reveal-delay-2">
                        <p className="text-inverse-on-surface text-sm mb-4">Or drop me a line directly</p>
                        <a
                            href="mailto:rameshalagumalai23@gmail.com"
                            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-on-primary rounded-full font-semibold shadow-2 hover:shadow-4 hover:brightness-110 hover:-translate-y-0.5 transition-all duration-200 ease-standard"
                        >
                            <i className="fa-solid fa-paper-plane"></i> rameshalagumalai23@gmail.com
                        </a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-inverse-surface p-6 text-center border-t border-white/5">
                <p className="text-inverse-on-surface text-[0.8125rem]">
                    © {new Date().getFullYear()} Ramesh Alagumalai.
                </p>
            </footer>
        </>
    );
}
